var personnelTypes = [

  { "name": "Technicien", "label": "اپراتور", value: 3 },

];

export default personnelTypes;
